import {
    GET_ALL_ACCESS_KEYS_BEGIN, GET_ALL_ACCESS_KEYS_SUCCESS, GET_ALL_ACCESS_KEYS_FAILURE,
    GET_ACCESS_KEY_BEGIN, GET_ACCESS_KEY_SUCCESS, GET_ACCESS_KEY_FAILURE,
    POST_ACCESS_KEY_BEGIN, POST_ACCESS_KEY_SUCCESS, POST_ACCESS_KEY_FAILURE,
    PUT_ACCESS_KEY_BEGIN, PUT_ACCESS_KEY_SUCCESS, PUT_ACCESS_KEY_FAILURE
} from '../constants/ActionTypes'

const initialState = {

    // Get All Keys
    allKeys: null,
    isLoadingAllKeys: false,
    hasErrorAllKeys: null,

    // Get Key
    selectedKey: null,
    isLoadingSelectedKey: false,
    hasErrorSelectedKey: null,

    // Post Key
    createdKey: null,
    isCreatingKey: false,
    hasErrorCreatedKey: null,

    // Update Key
    updatedKey: null,
    isUpdatingKey: false,
    hasErrorUpdatedKey: null
}

/**
 * @description Reducer function for managing access keys in the application state.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state of the access keys.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns {Object} - The updated state after applying the action.
 */
const ReducerAccessKey = (state = initialState, action) => {
    switch (action.type) {

    // Get All Keys
    case GET_ALL_ACCESS_KEYS_BEGIN: {
        return {
            ...state,
            isLoadingAllKeys: true
        }
    }
    case GET_ALL_ACCESS_KEYS_SUCCESS: {
        return {
            ...state,
            allKeys: action.payload,
            isLoadingAllKeys: false,
            hasErrorAllKeys: null
        }
    }
    case GET_ALL_ACCESS_KEYS_FAILURE: {
        return {
            ...state,
            allKeys: null,
            isLoadingAllKeys: false,
            hasErrorAllKeys: action.payload
        }
    }

    // Get Key
    case GET_ACCESS_KEY_BEGIN: {
        return {
            ...state,
            isLoadingSelectedKey: true
        }
    }
    case GET_ACCESS_KEY_SUCCESS: {
        return {
            ...state,
            selectedKey: action.payload,
            isLoadingSelectedKey: false,
            hasErrorSelectedKey: null
        }
    }
    case GET_ACCESS_KEY_FAILURE: {
        return {
            ...state,
            selectedKey: null,
            isLoadingSelectedKey: false,
            hasErrorSelectedKey: action.payload
        }
    }

    // Post Key
    case POST_ACCESS_KEY_BEGIN: {
        return {
            ...state,
            isCreatingKey: true
        }
    }
    case POST_ACCESS_KEY_SUCCESS: {
        return {
            ...state,
            createdKey: action.payload,
            isCreatingKey: false,
            hasErrorCreatedKey: null
        }
    }
    case POST_ACCESS_KEY_FAILURE: {
        return {
            ...state,
            createdKey: null,
            isCreatingKey: false,
            hasErrorCreatedKey: action.payload
        }
    }

    // Put Key
    case PUT_ACCESS_KEY_BEGIN: {
        return {
            ...state,
            isUpdatingKey: true
        }
    }
    case PUT_ACCESS_KEY_SUCCESS: {
        return {
            ...state,
            updatedKey: action.payload,
            isUpdatingKey: false,
            hasErrorUpdatedKey: null
        }
    }
    case PUT_ACCESS_KEY_FAILURE: {
        return {
            ...state,
            updatedKey: null,
            isUpdatingKey: false,
            hasErrorUpdatedKey: action.payload
        }
    }

    default: return state

    }
}

export default ReducerAccessKey